import { NUMERIC_REGEXP } from '../../../constants/regex';
import { Operators } from '../../../@types/serviceTypes';

import { RimmEntityType } from '../data/rimmEntityEnums';

function getRestrictions(entity: RimmEntityType, searchText: string) {
  switch (entity) {
    case RimmEntityType.commodity:
      return [
        NUMERIC_REGEXP.test(searchText)
          ? {
              value: searchText,
              field: 'code',
              operator: Operators.STARTS_WITH,
            }
          : {
              value: searchText,
              field: 'description',
              operator: Operators.CONTAINS,
            },
      ];

    default:
      return [
        {
          value: searchText,
          field: 'code',
          operator: Operators.STARTS_WITH,
        },
        {
          value: searchText,
          field: 'description',
          operator: Operators.CONTAINS,
        },
      ];
  }
}

export function getRestrictionsByCodes(codes: string[]) {
  return codes.map((code) => ({
    value: code,
    field: 'code',
    operator: Operators.EQUALS,
  }));
}

export default getRestrictions;
